import { render } from "./logoutView.vue?vue&type=template&id=fb797e1c&scoped=true"
import script from "./logoutView.vue?vue&type=script&lang=js"
export * from "./logoutView.vue?vue&type=script&lang=js"

import "./logoutView.vue?vue&type=style&index=0&id=fb797e1c&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb797e1c"]])

export default __exports__